import { z } from "zod";

export const searchSchema = z
  .object({
    title: z.string().optional(),
    author: z.string().optional(),
    isbn: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.isbn && !(data.title && data.author)) {
      if (!data.isbn) {
        ctx.addIssue({
          path: ["isbn"],
          code: z.ZodIssueCode.custom,
          message:
            "ISBN is required if title and author are not provided together",
        });
      }
      if (!data.title) {
        ctx.addIssue({
          path: ["title"],
          code: z.ZodIssueCode.custom,
          message: "Title is required if ISBN is not provided",
        });
      }
      if (!data.author) {
        ctx.addIssue({
          path: ["author"],
          code: z.ZodIssueCode.custom,
          message: "Author is required if ISBN is not provided",
        });
      }
    }
  });

export type SearchInput = z.infer<typeof searchSchema>;